exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#panelTags[data-v-5b081b02]{border:1px solid #00d1b2;background:#fff}.panel-block[data-v-5b081b02]{border:1px solid #00d1b2}a.panel-block.itemsCats[data-v-5b081b02]:hover{background-color:#c7faf2;color:#00d1b2}a.panel-block.itemsCats.is-active[data-v-5b081b02]{background-color:#00d1b2;color:#fff}.panel-block[data-v-5b081b02]:first-child,.panel-heading[data-v-5b081b02]:first-child,.panel-tabs[data-v-5b081b02]:first-child{border-top:#00d1b2}.panel-block.is-active .panel-icon[data-v-5b081b02]{color:#fff}.scroll-area[data-v-5b081b02]{position:relative;margin:auto;height:400px;border-radius:5px 5px 5px 5px;border:1px solid #00d1b2}.ps__thumb-x[data-v-5b081b02],.ps__thumb-y[data-v-5b081b02]{background-color:#00d1b2;width:10px}.column-blanco[data-v-5b081b02]{padding-bottom:70px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b081b02","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/Tags.vue
// module id = 2186
// module chunks = 0